import styled from "styled-components";

export const Container = styled.div`
  padding-top: 85px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding-bottom: 64px;
  height: 100%;
  overflow-y: scroll;

  .headerList {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 20px;

    .headerTitle {

      .title {
        font-weight: 200;
        width: 100%;
        font-size: 2rem;
      }
      .subtitle {
        margin-top: 5px;
        font-size: 1.2rem;
        color: rgb(0 0 0 / 60%);
      }
    }
    .action {
      display: inline-flex;
      button {
        margin-left: 16px;
        width: 104px;
      }
    }
  }
`;

export const ContainerModalFormLocation = styled.div`
  z-index: 2001;

  .MuiDialog-paper {
    width: 600px;

    .mHeader {

      .MuiTypography-root {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .content {
          font-weight: 200;
          min-width: 0;

          .subtitle {
            font-size: 1rem;
            color: #666666;
          }
        }
        .icon {
          display: flex;

          svg {
            font-size: 1.8em;
          }
        }
        .actions {
          display: flex;
          flex-wrap: nowrap;
          flex-shrink: 0;
          align-items: center;
          margin-left: 12px;

          button {
            background: #DDDDDD;

            .text {
              font-weight: 300;
            }
            svg {
              color: #707070;
            }
            &:hover {
              background-color:#FFFFFF;
            }
          }
        }
      }
    }
    .mContent {

      .MuiFormControl-root {
        width: 100%;

        .MuiFormHelperText-root {
          text-align: right;
          margin: 0;
        }
      }
      .checkboxes {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;

        .r-checkbox {
          display: flex;
          margin-left: 0;
          margin-right: 0;
          justify-content: flex-end;

          .MuiCheckbox-root {
            color: #707070;
          }
          .MuiFormControlLabel-label {
            font-size: 1.2em;
          }
          .MuiIconButton-root {
            position: relative;
            left: -10px;
          }
          .MuiFormControlLabel-label {
            position: relative;
            top: 1px;
          }
        }
      }
      .blockActions {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;

        .actions {

          button {
            background: #DDDDDD;

            .text {
              font-weight: 300;
            }
            svg {
              color: #707070;
            }
            &:hover {
              background-color:#FFFFFF;
            }
          }
        }
        .active {
          display: flex;
          margin-left: 0;
          margin-right: 0;
          justify-content: flex-end;

          .MuiCheckbox-root {
            color: #707070;
          }
          .MuiFormControlLabel-label {
            font-size: 1.2em;
          }
          .MuiIconButton-root {
            position: relative;
            left: -10px;
          }
          .MuiFormControlLabel-label {
            position: relative;
            top: 1px;
          }
        }
      }
      .blockCep {
        display: flex;

        button {
          background: #DDDDDD;
          width: 170px;
          margin: 8px 0 4px 15px;
          color: rgba(0, 0, 0, 0.87);
          height: auto;
          border-radius: 4px;
          text-transform: uppercase;

          span {
            font-weight: 300;
          }
          &:hover {
            background-color:#FFFFFF;
          }
          &:disabled {
            color: rgba(0, 0, 0, 0.26);
            background: #DDDDDD;
          }
        }
      }
      .finishPoint {

        .MuiCheckbox-root {
          color: #707070;
        }
      }
    }
    .mFooter {
      justify-content: space-between;
    }
  }
`;

export const ContainerModalMapMarker = styled.div`
  z-index: 2001;

  .MuiDialog-paper {
    max-width: 800px;
    width: 800px;

    .mContent {

      .MuiTypography-root {
        width: 100%;
      }
      .MuiFormControl-root {
        width: 100%;

        .MuiFormHelperText-root {
          text-align: right;
          margin: 0;
        }
      }
    }
  }
`;
